import React from 'react';
import { footerData } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 pb-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          {/* Logo */}
          <div className="flex items-baseline border border-white px-3 py-1">
            <span className="text-2xl font-black tracking-tighter text-white">MK</span>
            <span className="text-2xl font-extralight tracking-tighter text-white">118</span>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap justify-center gap-6">
            {footerData.links.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} MK118
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;